import { CartStatus } from '@core/enums/cart/cart-status.enum';
import { ICartItem } from '@core/interfaces/cart/cart-item.interface';
import { ICart } from '@core/interfaces/cart/cart.interface';
import { IGiftCardItem } from '@core/interfaces/cart/giftcard-item.interface';
import { IGiftCardsToBuyCartItem } from '@core/interfaces/cart/giftcards-to-buy-cart-item.interface';
import { AAGUID, Currency, parseArray, Status } from '@interticket/core';
import { Customer } from '../customer/customer.model';
import { CartItem } from './cart-item.model';
import { CartSeller } from './cart-seller.model';
import { GiftCardItem } from './giftcard-item.model';
import { GiftCardsToBuyCartItem } from './giftcards-to-buy-cart-item.model';

export class Cart implements ICart {

  readonly id: AAGUID;
  readonly currency: Currency;
  readonly user: CartSeller;
  readonly status: Status<CartStatus>;
  readonly cartItems: CartItem[];
  readonly giftCardsToBuy: GiftCardsToBuyCartItem[];
  readonly expiredTime: string;
  readonly customer: Customer;
  readonly giftCards: GiftCardItem[];
  readonly totalAmount: number;
  readonly totalPrice: number;

  constructor(iCart: ICart) {
    this.id = iCart.id;
    this.currency = iCart.currency;
    this.user = new CartSeller(iCart.user);
    this.status = new Status(iCart.status);
    this.expiredTime = iCart.expiredTime;
    this.cartItems = parseArray<ICartItem, CartItem>(iCart.cartItems, CartItem);
    this.giftCardsToBuy = parseArray<IGiftCardsToBuyCartItem, GiftCardsToBuyCartItem>(iCart.giftCardsToBuy, GiftCardsToBuyCartItem);
    this.customer = iCart.customer ? new Customer(iCart.customer) : null;
    this.giftCards = parseArray<IGiftCardItem, GiftCardItem>(iCart.giftCards, GiftCardItem);
    this.totalAmount = iCart.totalAmount;
    this.totalPrice = iCart.totalPrice;
  }

}
